import Cookies from 'js-cookie';
import { apiFetch } from '../../services/api';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8001';

const DoctorService = {
  async getClinicList() {
    try {
      const adminId = Cookies.get('adminid') || localStorage.getItem('adminid');
      if (!adminId) {
        throw new Error('Admin ID not found in cookies');
      }
      const response = await apiFetch(`${API_BASE_URL}/admin/getClinicList/${adminId}`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Failed to fetch clinic list');
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error fetching clinic list: ${error.message}`);
    }
  },

  async getSpecialityList() {
    try {
      const response = await apiFetch(`${API_BASE_URL}/admin/getDoctorSpeciality1`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Failed to fetch speciality list');
      }
      return await response.json();
    } catch (error) {
      throw new Error(`Error fetching speciality list: ${error.message}`);
    }
  },

  async login(username, password) {
    const payload = { username, password };
    try {
      const response = await apiFetch(`${API_BASE_URL}/admin/adminlogin`, {
        method: 'POST',
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to login');
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error during login: ${error.message}`);
    }
  },

  async addDoctor(doctorData, files) {
    const payload = {
      ...doctorData,
      profilePath: files.profilePhoto || undefined,
      licencePath: files.license || undefined,
      authorizedSign: files.authorizedSignature || undefined,
      commercialLicence: files.commercialLicense || undefined,
      civil_idPath: files.civilId || files.civilIdPath || undefined,
    };
    try {
      const response = await apiFetch(`${API_BASE_URL}/admin/addDoctor`, {
        method: 'POST',
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to add doctor');
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error adding doctor: ${error.message}`);
    }
  },

  async updateDoctor(doctorId, doctorData, files) {
    const payload = {
      ...doctorData,
      profilePath: files.profilePhoto || '',
      licencePath: files.license || '',
      authorizedSign: files.authorizedSignature || '',
      commercialLicence: files.commercialLicense || '',
      civil_idPath: files.civilId || files.civilIdPath || '',
    };

    try {
      const response = await apiFetch(`${API_BASE_URL}/admin/updateDoctor/${doctorId}`, {
        method: 'PUT',
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        throw new Error('Failed to update doctor');
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error updating doctor: ${error.message}`);
    }
  },

  async deleteDoctor(doctorId) {
    try {
      const response = await apiFetch(`${API_BASE_URL}/admin/deleteDoctor/${doctorId}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Failed to delete doctor');
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error deleting doctor: ${error.message}`);
    }
  },

  async uploadProfilePhoto(file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('module_id', '1');
    formData.append('pathLocation', 'PROFILE_IMAGES/');

    console.log('FormData contents for uploadProfilePhoto:');
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value instanceof File ? value.name : value}`);
    }

    try {
      const response = await apiFetch(`${API_BASE_URL}/admin/awsS3FileUpload`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to upload profile photo: ${response.status} ${response.statusText} - ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error uploading profile photo: ${error.message}`);
    }
  },

  async getAllDoctors() {
    try {
      const adminId = Cookies.get('adminid');
      if (!adminId) {
        throw new Error('Admin ID not found in cookies');
      }
      const response = await apiFetch(`${API_BASE_URL}/admin/admingetdoctordetails/${adminId}`);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch doctors: ${response.status} ${response.statusText} - ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error fetching doctors: ${error.message}`);
    }
  },

  async getDoctorAppointments(doctorId, clinicId) {
    const payload = {
      doctorId,
      clinicId,
    };

    try {
      const response = await apiFetch(`${API_BASE_URL}/doctor/getDoctorAppointments`, {
        method: 'POST',
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch appointments: ${response.status} ${response.statusText} - ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error fetching appointments: ${error.message}`);
    }
  }
};

export default DoctorService;
